import loadable from '@loadable/component';

const ProductTabProperties = loadable(() =>
  import(
    /* webpackChunkName: "ProductTabProperties" */ './product-tab-properties'
  )
);

export default ProductTabProperties;
